import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const allowsCopy = (target) =>
  target instanceof Element &&
  target.closest(".admin-page, input, textarea, [contenteditable]:not([contenteditable='false'])");

export default function SiteBehavior() {
  const { pathname } = useLocation();
  const isAdmin = /^\/admin(?:\/|$)/.test(pathname);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  useEffect(() => {
    document.documentElement.classList.toggle("public-content", !isAdmin);
    const preventCopy = (event) => {
      if (!isAdmin && !allowsCopy(event.target)) event.preventDefault();
    };
    document.addEventListener("copy", preventCopy);
    document.addEventListener("cut", preventCopy);
    return () => {
      document.documentElement.classList.remove("public-content");
      document.removeEventListener("copy", preventCopy);
      document.removeEventListener("cut", preventCopy);
    };
  }, [isAdmin]);

  return null;
}
